import ExternalClientCounterIcon from '@material-ui/icons/ViewList';

import ExternalClientCounterList from './ExternalClientCounterList';

export default {
  list: ExternalClientCounterList,
  icon: ExternalClientCounterIcon,
};
